module.exports = __webpack_public_path__ + "static/assets/57b9b3d6444c297bb69a434d8b98b662.png";